module.exports = __webpack_public_path__ + "img/2024-21.510e4124.jpg";